"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _infoMessage = require("@/api/infoMessage");
var _permission = require("@/utils/permission");
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _validate = require("@/utils/validate");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = {
  name: 'infoReason',
  data: function data() {
    return {
      listLoading: true,
      loading: false,
      pram: {
        value: '',
        start_time: ''
      }
    };
  },
  components: {
    Tinymce: _index.default
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _infoMessage.getCompanyExplain)().then(function (res) {
        _this.pram = res[0];
        _this.listLoading = false;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    submitForm: (0, _validate.Debounce)(function () {
      var _this2 = this;
      this.$refs.pram.validate(function (valid) {
        if (valid) {
          _this2.loading = true;
          var _this2$pram = _this2.pram,
            key = _this2$pram.key,
            id = _this2$pram.id,
            start_time = _this2$pram.start_time,
            value = _this2$pram.value;
          var data = {
            config_list: [{
              key: key,
              id: id,
              start_time: start_time,
              value: value
            }]
          };
          (0, _infoMessage.saveSystemConfig)(data).then(function (res) {
            _this2.$message.success(_this2.$t('xzcg'));
            _this2.loading = false;
            _this2.getList();
          }).catch(function () {
            _this2.loading = false;
          });
        } else {
          return false;
        }
      });
    })
  }
};
exports.default = _default;